import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations } from "@/i18n/translations";

const LangContext = createContext(null);
const KEY = "vantex_lang";

export function getLang() {
  const saved = localStorage.getItem(KEY);
  return translations[saved] ? saved : "en";
}

export function translate(lang, path, vars) {
  const dict = translations[lang] || translations.en;
  let val = path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), dict);
  if (val === undefined) val = path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), translations.en);
  if (typeof val !== "string") return path;
  if (vars) Object.entries(vars).forEach(([k, v]) => { val = val.replaceAll(`{${k}}`, String(v)); });
  return val;
}

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(getLang);
  const setLang = useCallback((l) => { localStorage.setItem(KEY, l); setLangState(l); document.documentElement.lang = l; }, []);
  const t = useCallback((path, vars) => translate(lang, path, vars), [lang]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
